import {
	CAMPAIGN_REQUEST,
	CAMPAIGN_CREATE,
	CAMPAIGN_GET_LIST,
	CAMPAIGN_GET,
	CAMPAIGN_SUCCESS,
	CAMPAIGN_ERROR,
	CAMPAIGN_SET_NEW,
	CAMPAIGN_SEND_CONTACT,
	CAMPAIGN_SEARCH_CONTACTS,
	CAMPAIGN_GET_STATS,
	CAMPAIGN_ADD_PROSPECTS,
} from '../types';

import axios from '../axios';
import _ from 'lodash';

const state = {
	newCampaign: null,
	currentCampaign: null,
	campaigns: [],
	isLoading: false,
	error: null,
	stats: {}
};

const getters = {
	getCurrentCampaign: (state) => state.currentCampaign,
	getCampaigns: (state) => state.campaigns,
	isCampaignLoading: (state) => state.isLoading,
	getCampaignError: (state) => state.error,
	getNewCampaign: (state) => state.newCampaign,
	getCampaignStats: (state) => state.stats
};
const formatTags = (tags) => {
	return tags.map((tag) => tag.text);
};
const actions = {
	/*
    campaign:
      city: []
			companySize: "1~200"
			contactCount: 3
			country: []
			industries: ["Advertising", "CleanTech", "Email", "Publishing"]
			keyword: []
			name: "asfasdf"
			region: []
			roles: ["C-level", "VP"] 
  */
	[CAMPAIGN_CREATE]: ({ commit }, campaign) => {
		return new Promise((resolve, reject) => {
			commit(CAMPAIGN_REQUEST);

			const { companySize, contactCount, industries, subindustries, name, roles, seniority } = campaign;

			const data = {
				companySize,
				contactCount,
				industries,
				subindustries,
				name,
				roles,
				seniority,
				keyword: campaign.keywordTags ? formatTags(campaign.keywordTags) : [],
				country: campaign.countryTags ? formatTags(campaign.countryTags) : [],
				city: campaign.cityTags ? formatTags(campaign.cityTags) : [],
				region: campaign.regionTags ? formatTags(campaign.regionTags) : []
			};

			axios
				.post('/api/v1/campaigns/', data)
				.then((resp) => {
					commit(CAMPAIGN_SUCCESS, { campaign: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(CAMPAIGN_ERROR, err);
					reject(err);
				});
		});
	},
	[CAMPAIGN_ADD_PROSPECTS]: ({ commit, state }) => {
		return new Promise((resolve, reject) => {
			commit(CAMPAIGN_REQUEST);

			axios
				.post(`/api/v1/campaigns/${state.currentCampaign._id}/add_prospects/`)
				.then((resp) => {
					commit(CAMPAIGN_SUCCESS, { campaign: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(CAMPAIGN_ERROR, err);
					reject(err);
				});
		});
	},
	[CAMPAIGN_SEARCH_CONTACTS]: ({ commit, state }, selected) => {
		return new Promise((resolve, reject) => {
			commit(CAMPAIGN_REQUEST);

			axios.post(`/api/v1/campaigns/${state.currentCampaign._id}/contacts/`, { companies: selected })
				.then((resp) => {
					commit(CAMPAIGN_SUCCESS, { campaign: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(CAMPAIGN_ERROR, err);
					reject(err);
				});
		});
	},
	[CAMPAIGN_GET_LIST]: ({ commit }, campaign) => {
		return new Promise((resolve, reject) => {
			commit(CAMPAIGN_REQUEST);

			axios
				.get('/api/v1/campaigns/')
				.then((resp) => {
					commit(CAMPAIGN_SUCCESS, { campaigns: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(CAMPAIGN_ERROR, err);
					reject(err);
				});
		});
	},
	[CAMPAIGN_GET_STATS]: ({ commit }) => {
		return new Promise((resolve, reject) => {
			commit(CAMPAIGN_REQUEST);

			axios
				.get('/api/v1/campaigns/stats/')
				.then((resp) => {
					commit(CAMPAIGN_SUCCESS, { stats: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(CAMPAIGN_ERROR, err);
					reject(err);
				});
		});
	},
	[CAMPAIGN_GET]: ({ commit }, id) => {
		return new Promise((resolve, reject) => {
			commit(CAMPAIGN_REQUEST);

			axios
				.get(`/api/v1/campaigns/${id}/`)
				.then((resp) => {
					commit(CAMPAIGN_SUCCESS, { campaign: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(CAMPAIGN_ERROR, err);
					reject(err);
				});
		});
	},
	[CAMPAIGN_SEND_CONTACT]: ({ state, commit }, { type, subject, body, profile_id, template_id }) => {
		return new Promise((resolve, reject) => {
			commit(CAMPAIGN_REQUEST);

			axios
				.post(`/api/v1/campaigns/${state.currentCampaign._id}/send_contact/`, {
					subject,
					body,
					type,
					profile_id,
					template_id
				})
				.then((resp) => {
					console.log(resp);
					commit(CAMPAIGN_SUCCESS, { campaign: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(CAMPAIGN_ERROR, err);
					reject(err);
				});
		});
	}
};

const mutations = {
	[CAMPAIGN_REQUEST]: (state) => {
		state.isLoading = true;
	},
	[CAMPAIGN_SUCCESS]: (state, { campaign, campaigns, stats }) => {
		state.isLoading = false;
		if (campaign) {
			state.currentCampaign = campaign;
			state.newCampaign = null;
		}
		if (campaigns) {
			state.campaigns = campaigns;
		}

		if (stats) {
			state.stats = stats;
		}
	},
	[CAMPAIGN_ERROR]: (state, error) => {
		state.isLoading = false;
		if (error) state.error = error;
	},
	[CAMPAIGN_SET_NEW]: (state, newCampaign) => {
		state.newCampaign = newCampaign;
	},
	[CAMPAIGN_GET]: (state, id) => {
		if (!id) {
			state.currentCampaign = null;
			return;
		}
		state.currentCampaign = state.campaigns.find((campaign) => campaign._id === id);
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
